import { inject, Pipe, type PipeTransform } from '@angular/core';
import { AppService } from '../services/app.service';


//NOTE: this sync pipe works because app.component.ts waits for reseller info to load before rendering the app. Otherwise it would be a problem and we need to use async pipe in the template
@Pipe({
  name: 'trans',
  standalone: true,
  pure: true,
})
export class TranslationPipe implements PipeTransform {
  private app = inject(AppService);

  transform(value: string): string {
    return this.app.translate(value);
  }
}
